var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-product",on:{"click":_vm.test}},[_c('md-card-header',{staticClass:"md-card-header-image"},[_vm._t("imageHeader")],2),_c('md-card-content',[_vm._t("title"),_vm._t("description")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }